export const BilletTypes = {
  paidAccounts: "paidAccounts",
  accountsReceivable: "accountsReceivable",
};
